import { render, staticRenderFns } from "./LinkBlock.vue?vue&type=template&id=6c7620d1&scoped=true&"
import script from "./LinkBlock.vue?vue&type=script&lang=js&"
export * from "./LinkBlock.vue?vue&type=script&lang=js&"
import style0 from "./LinkBlock.vue?vue&type=style&index=0&id=6c7620d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7620d1",
  null
  
)

export default component.exports